import { render, staticRenderFns } from "./FormulateStatusBadgeMultiple.vue?vue&type=template&id=094d074b&"
import script from "./FormulateStatusBadgeMultiple.vue?vue&type=script&lang=js&"
export * from "./FormulateStatusBadgeMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094d074b')) {
      api.createRecord('094d074b', component.options)
    } else {
      api.reload('094d074b', component.options)
    }
    module.hot.accept("./FormulateStatusBadgeMultiple.vue?vue&type=template&id=094d074b&", function () {
      api.rerender('094d074b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/status-badge-multiple/FormulateStatusBadgeMultiple.vue"
export default component.exports